import { Instance, TableCalculation } from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from './assetService';
import { BuildingService } from './buildingService';
import { DistrictService } from './districtService';
import { GroupService } from './groupService';
import { LanguageService } from './languageService';
import { PersonService } from './personService';
import { PlanPreyService } from './planPreyService';
import { PlanService } from './planService';
import { ReportService } from './reportService';
import { WildService } from './wildService';

export class ReportBuildingService extends ReportService {
    static readonly inject = [
        'instances',
        'languageService',
        'assetService',
        'personService',
        'groupService',
        'buildingService',
        'districtService',
        'planService',
        'wildService',
        'planPreyService',
    ];

    constructor(
        instances: Instance,
        $languageService: LanguageService,
        $assetService: AssetService,
        $personService: PersonService,
        $groupService: GroupService,
        $buildingService: BuildingService,
        $districtService: DistrictService,
        $planService: PlanService,
        $wildService: WildService,
        $planPreyService: PlanPreyService,
    ) {
        super(
            instances,
            $languageService,
            $assetService,
            $personService,
            $groupService,
            $buildingService,
            $districtService,
            $planService,
            $wildService,
            $planPreyService,
        );
    }

    getTableCalculations(): TableCalculation {
        return {
            ...this._getTableCalculations(),
            name: (object) => {
                return this.helper.createLink(
                    object.get<string>('name'),
                    (href) => {
                        this.state.go(href);
                    },
                    this.state.resolveUrl('buildings.show', {
                        buildingId: [object.get<string>('id')],
                    }),
                );
            },
        };
    }
}

export const reportBuildingService = app.service('reportBuildingService', ReportBuildingService);
